<script setup lang="ts">
import type { SeparatorProps } from '#ui/types';
import lodashOmit from 'lodash-es/omit';

export interface StoryblokUiSeparatorProps {
    blok: StoryblokUiSeparator;
}

// PROPS
const { blok } = defineProps<StoryblokUiSeparatorProps>();

// DATA
const MT_CLASSES: Record<string, string> = {
    '0': 'mt-0',
    '1': 'mt-1',
    '2': 'mt-2',
    '3': 'mt-3',
    '4': 'mt-4',
    '5': 'mt-5',
    '6': 'mt-6',
    '8': 'mt-8',
    '10': 'mt-10',
    '12': 'mt-12',
    '16': 'mt-16',
    '20': 'mt-20',
    '24': 'mt-24',
};
const MB_CLASSES: Record<string, string> = {
    '0': 'mb-0',
    '1': 'mb-1',
    '2': 'mb-2',
    '3': 'mb-3',
    '4': 'mb-4',
    '5': 'mb-5',
    '6': 'mb-6',
    '8': 'mb-8',
    '10': 'mb-10',
    '12': 'mb-12',
    '16': 'mb-16',
    '20': 'mb-20',
    '24': 'mb-24',
};

const separatorProps = computed<SeparatorProps>(() =>
    lodashOmit(storyblokOmitEmptyValues<StoryblokUiSeparator>(blok), ['_uid', 'component', 'marginTop', 'marginBottom'])
);
const classes = computed(() => [blok.marginTop ? MT_CLASSES[blok.marginTop] : '', blok.marginBottom ? MB_CLASSES[blok.marginBottom] : '']);
</script>

<template>
    <USeparator v-editable="blok" v-bind="separatorProps" :class="classes" />
</template>
